import { createValidation } from '../../../utils/validation';

export const createNonConformityTypeValidation = (fields) => {
  const validation = createValidation(fields);
  return {
    schema: validation.schema,
    validateData: validation.validateData,
    validateNonConformityTypeData: validation.validateData,
    validateField: validation.validateField
  };
};

export default createNonConformityTypeValidation;
